import React from 'react';
import { Container } from './styles';

interface ToggleListCalendarProps {
  filterPageType: string;
  setFilterPageType: React.Dispatch<React.SetStateAction<string>>;
}

const ToggleListCalendar = (props: ToggleListCalendarProps) => {
  const { filterPageType, setFilterPageType } = props;

  return (
    <Container className="btn-group mr-2 mb-1" role="group">
      <button
        type="button"
        className={`btn-change-view btn btn-management btn-sm ${
          filterPageType === 'List' && 'active'
        }`}
        aria-label="Lista"
        onClick={() => setFilterPageType('List')}
      >
        <i className="material-icons">list</i>
      </button>
      <button
        type="button"
        className={`btn-change-view btn btn-management btn-sm ${
          filterPageType === 'Calendar' && 'active'
        }`}
        aria-label="Calendário"
        onClick={() => setFilterPageType('Calendar')}
      >
        <i className="material-icons">calendar_month</i>
      </button>
    </Container>
  );
};

export default ToggleListCalendar;
